import React from 'react';
import iconify from '../iconify';

const CompletedIcon = ({customColor, ...props}) => (
  <svg width="1em" height="1em" viewBox="0 0 121.2 84.27" {...props}>
    <path
      fill={customColor ? customColor : 'currentColor'}
      d="M37.87,81.89a8.27,8.27,0,0,0,5.65,2.38,9,9,0,0,0,5.8-2.38l69.46-68.27a7.75,7.75,0,0,0,0-11.24,8.07,8.07,0,0,0-11.44,0L43.52,65.1,13.86,35.8a8.07,8.07,0,0,0-11.44,0A7.73,7.73,0,0,0,2.42,47Z"
    />
  </svg>
);

export default iconify(CompletedIcon);
